/**
 * @desc: 设置localStorage
 * @param {string} name
 * @param {string} content
 * @return {*}
 * @author: 龙健
 */
export default function setLocal(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}
